module.exports = __webpack_public_path__ + "img/suporte_kf.c09f3bc5.png";